module.exports = __webpack_public_path__ + "static/media/editSelected.e5f2c207.svg";